import { Option, Select } from "@mui/joy";
import type { CanvasType } from "../types";

interface CanvasTypeSelectProps {
  value: CanvasType | undefined;
  onChange: (value: CanvasType) => void;
  disabled?: boolean;
}

export function CanvasTypeSelect({
  value,
  onChange,
  disabled = false,
}: CanvasTypeSelectProps) {
  return (
    <Select
      size="sm"
      value={value ?? "entry"}
      disabled={disabled}
      onChange={(_, nextValue) => {
        if (nextValue) onChange(nextValue as CanvasType);
      }}
      sx={{ minWidth: 120 }}
    >
      <Option value="entry">Entry Form</Option>
      <Option value="browse">Browse</Option>
      <Option value="report">Report</Option>
      <Option value="dashboard">Dashboard</Option>
    </Select>
  );
}
